
<template lang="pug">
    div.policy-table
        el-table(
            :data="tableData"
        )
            el-table-column(
                align="center"
                v-for="item in tableItems"
                :key="item.prop"
                v-bind="{ ...item }"
            )
                template(slot-scope="scope")
                    div(v-if="item.prop==='owner'")
                        div(v-if="scope.row.ownerName || scope.row.ownerPhone" )
                            div {{scope.row.ownerName | fieldVaild}}
                            div {{scope.row.ownerPhone | fieldVaild}}
                        div(v-else) --
                    div(v-else-if="item.prop==='insured'")
                        div(v-if="scope.row.insuredName || scope.row.insuredPhone" )
                            div {{scope.row.insuredName | fieldVaild}}
                            div {{scope.row.insuredPhone | fieldVaild}}
                        div(v-else) --
                    div(v-else-if="item.prop==='operator'")
                        div(v-if="scope.row.operatorName || scope.row.operatorPhone" )
                            div {{scope.row.operatorName | fieldVaild}}
                            div {{scope.row.operatorPhone | fieldVaild}}
                        div(v-else) --
                    div(v-else-if="item.prop==='riskType'")
                        div {{scope.row[item.prop] | riskLabel | fieldVaild}}
                    div(v-else-if="item.prop==='policyStartDate' && scope.row[item.prop]") {{ scope.row[item.prop] | dateFormat('YYYY/MM/DD HH:mm:ss') | fieldVaild }}
                    div(v-else-if="item.prop==='payTime' && scope.row[item.prop]") {{ scope.row[item.prop] | dateFormat('YYYY/MM/DD HH:mm:ss') | fieldVaild }}
                    div(v-else-if="item.prop==='policyTime' && scope.row[item.prop]") {{ scope.row[item.prop] | dateFormat('YYYY/MM/DD HH:mm:ss') | fieldVaild }}
                    div(v-else) {{ scope.row[item.prop] | fieldVaild }}
            el-table-column(
                label="操作"
                width="80px"
                align="center"
                fixed="right"
            )
                template(slot-scope="scope")
                    div
                        el-button(
                            type="text"
                            @click="showDetail(scope.row)"
                        ) 详情
</template>
<script>

import { mapState } from 'vuex';

export default {
    name: 'PolicyTable',
    computed: {
        ...mapState('user', [
            'userInfo',
        ]),
    },
    props: {
        tableData: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            tableItems: [
                {
                    prop: 'vin',
                    label: '车架号',
                    width: 150,
                },
                {
                    prop: 'licenseNo',
                    label: '车牌号',
                },
                {
                    prop: 'owner',
                    label: '车主',
                    width: 130,
                },
                {
                    prop: 'insured',
                    label: '被保人',
                    width: 130,
                },
                {
                    prop: 'riskType',
                    label: '险别',
                    width: 80,
                },
                {
                    prop: 'companyName',
                    label: '保司名称',
                    width: 160,
                },
                {
                    prop: 'premium',
                    label: '保费',
                    width: 100,
                },
                {
                    prop: 'vehicleTax',
                    label: '车船税',
                    width: 80,
                },
                {
                    prop: 'policyStartDate',
                    label: '保险起期',
                    width: 150,
                },
                {
                    prop: 'policyNo',
                    label: '保单号',
                    width: 130,
                },
                {
                    prop: 'orderId',
                    label: '关联订单号',
                    width: 160,
                },
                {
                    prop: 'operator',
                    label: '业务员',
                    width: 130,
                },
                {
                    prop: 'payTime',
                    label: '平台支付时间',
                    width: 150,
                },
                {
                    prop: 'policyTime',
                    label: '承保时间',
                    width: 150,
                },
            ],
        };
    },
    filters: {
        riskLabel(val) {
            const riskType = {
                TCI: '交强险',
                VCI: '商业险',
            };
            return riskType[val];
        },
    },
    created() {
        if (this.userInfo.mode === 3) {
            const orgNameTable = {
                prop: 'orgName',
                label: '门店名称',
                width: '220',
            };
            this.tableItems.unshift(orgNameTable);
        }
    },
    methods: {
        showDetail(row) {
            const { navType } = this.$route.query;
            this.$router.push({
                name: 'AutoInsurancePolicyListDetail',
                query: {
                    navType,
                    id: row.id,
                },
            });
        },
        refreshList() {
            this.$emit('refreshList');
        },
    },
};
</script>
<style lang="scss">
    .policy-table{
        .el-table td div {
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .el-table__fixed-body-wrapper .el-table__body{
            tbody tr td{
                padding: 0;
                height: 50px !important;
            }
        }
        .handle-btns {
            display: flex;
            justify-content: center;
        }
    }
</style>
